import { Box, CircularProgress, Container, Grid, Stack, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ProductsCard from './ProductsCard'
import { useTranslation } from 'react-i18next';

const ResultElements = ({ items, filter, interLoad, api }) => {
  
  const { t, i18n } = useTranslation(['translation']);

  const [showProds, setShowProds] = useState(items ? items : null);

  useEffect(() => {
    if (items) {
      let displayItems = filter['category'].length > 0
        ? items.filter(item => filter['category'].includes(item.category_name))
        : items
      // console.log(filter)
      setShowProds(
        filter['sex'] === 'All' ? 
          displayItems.filter(item => item.price <= filter['price'][1] && item.price >= filter['price'][0])
        :
          (displayItems.filter(item => item.price <= filter['price'][1] && item.price >= filter['price'][0]))
          .filter(item => item.gender === filter['sex'])
      );

    } else {
      setShowProds(null);
    }
  }, [items, filter])

  useEffect(() => {
    if(interLoad) {
      setShowProds(null)
    }
  }, [interLoad])

  return (

    <Box flex={4} p={{ xs: 0 }}>
      <Container component="section" maxWidth="lg" sx={{ marginTop: {xs:"75px", sm:"35px"}, marginBottom: {xs:"95px", sm:"35px"} }}>
        {
          showProds ?
              showProds.length > 0
                ?
                <Grid container spacing={3}>
                  {
                    showProds.map(item => (
                      <Grid item xl={3} lg={3} md={4} xs={6} key={item.item_id}>
                        <ProductsCard item={item} api={api}/>
                      </Grid>
                    ))
                  }
                </Grid>
                : <Box display='flex' justifyContent='center' paddingTop='25%'>
                  <Typography variant='h5'>{t('no matching product')}</Typography>
                </Box>
            :
            <Box display='flex' justifyContent='center' paddingTop='25%'>
              <Stack direction="column" spacing={2}>
                <Typography variant="h6">{t('Loading AI recommendations')}</Typography>
                <Box display='flex' justifyContent='center'>
                  <CircularProgress color="inherit" size={65} />
                </Box>
              </Stack>
            </Box>
        }
      </Container>
    </Box>

  )
}

export default ResultElements